(function() {
  'use strict';

  // Custom Review Scroll Functionality (Text Reviews Only)
  class ReviewScroll {
    constructor() {
      this.scrollContainer = null;
      this.leftBtn = null;
      this.rightBtn = null;
      this.minReviewsToShow = 3; // Show "レビュー募集中" if less than this
      this.init();
    }

    getMinReviews() {
      // Get min reviews from data attribute if available
      if (this.scrollContainer) {
        const minReviews = parseInt(this.scrollContainer.getAttribute('data-min-reviews'));
        if (!isNaN(minReviews) && minReviews > 0) {
          return minReviews;
        }
      }
      return this.minReviewsToShow;
    }

    init() {
      // Wait for Judge.me to load
      if (typeof window.judgeme === 'undefined') {
        // Check periodically for Judge.me
        const checkInterval = setInterval(() => {
          if (typeof window.judgeme !== 'undefined') {
            clearInterval(checkInterval);
            this.setupScroll();
            this.extractTextReviews();
          }
        }, 500);

        // Timeout after 10 seconds
        setTimeout(() => {
          clearInterval(checkInterval);
          this.setupScroll();
          this.extractTextReviews();
        }, 10000);
      } else {
        this.setupScroll();
        this.extractTextReviews();
      }
    }

    setupScroll() {
      this.scrollContainer = document.getElementById('photo-reviews-scroll');
      if (!this.scrollContainer) return;

      this.leftBtn = document.querySelector('.scroll-btn-left');
      this.rightBtn = document.querySelector('.scroll-btn-right');

      // Setup scroll buttons
      if (this.leftBtn) {
        this.leftBtn.addEventListener('click', () => this.scrollLeft());
      }

      if (this.rightBtn) {
        this.rightBtn.addEventListener('click', () => this.scrollRight());
      }

      // Update button visibility on scroll
      this.scrollContainer.addEventListener('scroll', () => {
        this.updateScrollButtons();
      });

      // Initial button state
      this.updateScrollButtons();

      // Touch/swipe support for mobile
      this.setupTouchScroll();
    }

    scrollLeft() {
      if (!this.scrollContainer) return;
      const scrollAmount = this.scrollContainer.offsetWidth * 0.8;
      this.scrollContainer.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth'
      });
    }

    scrollRight() {
      if (!this.scrollContainer) return;
      const scrollAmount = this.scrollContainer.offsetWidth * 0.8;
      this.scrollContainer.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }

    updateScrollButtons() {
      if (!this.scrollContainer) return;

      const { scrollLeft, scrollWidth, clientWidth } = this.scrollContainer;
      const isAtStart = scrollLeft <= 10;
      const isAtEnd = scrollLeft >= scrollWidth - clientWidth - 10;

      if (this.leftBtn) {
        this.leftBtn.classList.toggle('hidden', isAtStart);
      }

      if (this.rightBtn) {
        this.rightBtn.classList.toggle('hidden', isAtEnd);
      }
    }

    setupTouchScroll() {
      if (!this.scrollContainer) return;

      let isDown = false;
      let startX;
      let scrollLeft;

      this.scrollContainer.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX - this.scrollContainer.offsetLeft;
        scrollLeft = this.scrollContainer.scrollLeft;
      });

      this.scrollContainer.addEventListener('mouseleave', () => {
        isDown = false;
      });

      this.scrollContainer.addEventListener('mouseup', () => {
        isDown = false;
      });

      this.scrollContainer.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - this.scrollContainer.offsetLeft;
        const walk = (x - startX) * 2;
        this.scrollContainer.scrollLeft = scrollLeft - walk;
      });
    }

    extractTextReviews() {
      // Wait a bit for Judge.me to render
      setTimeout(() => {
        if (!this.scrollContainer) return;
        
        const judgeMeReviews = document.querySelectorAll('.jdgm-rev');
        const approvedReviews = Array.from(judgeMeReviews).filter(review => {
          // Only show approved reviews (published reviews)
          return review.offsetParent !== null; // Visible reviews
        });

        if (!approvedReviews.length) {
          // Show empty message if no reviews
          const placeholder = this.scrollContainer?.querySelector('.photo-reviews-placeholder');
          if (placeholder) {
            placeholder.style.display = 'block';
          }
          return;
        }

        // Check if review count is less than minimum
        const minReviews = this.getMinReviews();
        if (approvedReviews.length < minReviews) {
          const placeholder = this.scrollContainer?.querySelector('.photo-reviews-placeholder');
          if (placeholder) {
            placeholder.style.display = 'block';
            // Update message to show "レビュー募集中"
            const messageEl = placeholder.querySelector('.reviews-empty-message');
            if (messageEl) {
              messageEl.textContent = 'レビュー募集中';
            }
          }
          // Still show existing reviews
        } else {
          // Hide placeholder if enough reviews
          const placeholder = this.scrollContainer?.querySelector('.photo-reviews-placeholder');
          if (placeholder) {
            placeholder.style.display = 'none';
          }
        }

        // Extract all text reviews (no photo requirement)
        approvedReviews.forEach((review) => {
          const reviewText = review.querySelector('.jdgm-rev__body');
          const reviewAuthor = review.querySelector('.jdgm-rev__author');
          const reviewRating = review.querySelector('.jdgm-rev__rating');
          const reviewDate = review.querySelector('.jdgm-rev__timestamp');

          // Show review if it has text OR rating (text-only reviews are fine)
          if (reviewText || reviewRating) {
            this.createTextReviewCard(review, {
              text: reviewText,
              author: reviewAuthor,
              rating: reviewRating,
              date: reviewDate
            });
          }
        });

        // Update scroll buttons after content is added
        setTimeout(() => {
          this.updateScrollButtons();
        }, 100);
      }, 1000);
    }

    createTextReviewCard(originalReview, data) {
      if (!this.scrollContainer) return;

      // Check if card already exists
      const reviewId = originalReview.dataset.reviewId || 
                      originalReview.getAttribute('data-review-id') || 
                      Date.now() + Math.random();
      const existingCard = this.scrollContainer.querySelector(`[data-review-index="${reviewId}"]`);
      if (existingCard) return;

      const card = document.createElement('div');
      card.className = 'photo-review-card text-review-card';
      card.setAttribute('data-review-index', reviewId);

      // Get text content
      const textContent = data.text ? data.text.textContent.trim() : '';
      const authorName = data.author ? data.author.textContent.trim() : '匿名';
      const dateText = data.date ? data.date.textContent.trim() : '';

      // Get rating stars
      const ratingStars = data.rating ? this.getRatingStars(data.rating) : '';

      // Build card HTML (no image, text-only)
      card.innerHTML = `
        <div class="photo-review-content">
          <div class="photo-review-header">
            <span class="photo-review-author">${this.escapeHtml(authorName)}</span>
            <span class="photo-review-date">${this.escapeHtml(dateText)}</span>
          </div>
          ${ratingStars ? `<div class="photo-review-rating">${ratingStars}</div>` : ''}
          ${textContent ? `<p class="photo-review-text">${this.escapeHtml(textContent)}</p>` : ''}
          <div class="photo-review-verified">
            <svg class="photo-review-verified-icon" viewBox="0 0 16 16" fill="currentColor">
              <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
            </svg>
            購入者レビュー
          </div>
        </div>
      `;

      // Add click handler to open full review
      card.addEventListener('click', () => {
        originalReview.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      // Remove placeholder if exists and we have reviews
      const placeholder = this.scrollContainer.querySelector('.photo-reviews-placeholder');
      if (placeholder && this.scrollContainer.querySelectorAll('.photo-review-card').length > 0) {
        placeholder.style.display = 'none';
      }

      this.scrollContainer.appendChild(card);
    }

    getRatingStars(ratingElement) {
      // Extract rating from Judge.me rating element
      const rating = ratingElement.getAttribute('data-score') || 
                     ratingElement.getAttribute('aria-label')?.match(/\d+/)?.[0] || 
                     ratingElement.querySelector('.jdgm-star')?.getAttribute('data-score') ||
                     '5';
      const ratingNum = parseInt(rating);
      
      let stars = '';
      for (let i = 0; i < 5; i++) {
        if (i < ratingNum) {
          stars += '<span class="star">★</span>';
        } else {
          stars += '<span class="star" style="color: #ddd;">★</span>';
        }
      }
      return stars;
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new ReviewScroll();
      initReviewButtonHandler();
    });
  } else {
    new ReviewScroll();
    initReviewButtonHandler();
  }

  // Re-initialize on dynamic content updates
  document.addEventListener('shopify:section:load', () => {
    setTimeout(() => {
      new ReviewScroll();
      initReviewButtonHandler();
    }, 500);
  });

  // Listen for Judge.me widget updates
  if (typeof window.judgeme !== 'undefined') {
    document.addEventListener('judgeme:reviews-loaded', () => {
      setTimeout(() => {
        new ReviewScroll();
      }, 500);
    });
  }

  // Handle review button click with purchase verification
  function initReviewButtonHandler() {
    const reviewButton = document.querySelector('.btn-write-review[data-judgeme-write-review]');
    if (!reviewButton) return;

    const hasPurchased = reviewButton.getAttribute('data-has-purchased') === 'true';
    const messageModal = document.getElementById('review-purchase-message');
    const messageText = messageModal?.querySelector('.review-purchase-message-text');
    const closeButton = messageModal?.querySelector('.review-purchase-message-close');

    // Get custom message from section settings if available
    const section = reviewButton.closest('.product-reviews-custom-section');
    const customMessage = section?.dataset?.purchaseMessage;
    if (customMessage && messageText) {
      messageText.textContent = customMessage;
    }

    // Remove existing event listeners by cloning the button
    const newButton = reviewButton.cloneNode(true);
    reviewButton.parentNode.replaceChild(newButton, reviewButton);

    newButton.addEventListener('click', function(e) {
      // If customer hasn't purchased, show message and prevent default
      if (!hasPurchased) {
        e.preventDefault();
        e.stopPropagation();
        
        if (messageModal) {
          messageModal.style.display = 'flex';
        }
        return false;
      }
      
      // If customer has purchased, open Judge.me review form
      e.preventDefault();
      e.stopPropagation();
      
      // Function to try opening Judge.me review form
      const tryOpenReviewForm = () => {
        let formOpened = false;
        
        // Method 1: Find Judge.me's write review link in the widget (even if hidden by CSS)
        const judgeMeWidget = document.getElementById('judgeme_product_reviews');
        if (judgeMeWidget) {
          const judgeMeWriteLink = judgeMeWidget.querySelector('.jdgm-write-rev-link, a[href*="write-review"], .jdgm-write-review, [data-judgeme-write-review]');
          if (judgeMeWriteLink) {
            // Temporarily show and click
            const originalDisplay = judgeMeWriteLink.style.display;
            judgeMeWriteLink.style.display = 'block';
            judgeMeWriteLink.style.visibility = 'visible';
            judgeMeWriteLink.style.opacity = '1';
            judgeMeWriteLink.click();
            // Restore original display after a moment
            setTimeout(() => {
              judgeMeWriteLink.style.display = originalDisplay;
            }, 100);
            formOpened = true;
          }
        }
        
        // Method 2: Use Judge.me API if available
        if (!formOpened && typeof window.judgeme !== 'undefined') {
          const productId = newButton.getAttribute('data-product-id');
          if (productId) {
            // Try different Judge.me API methods
            if (window.judgeme.openReviewForm) {
              window.judgeme.openReviewForm(productId);
              formOpened = true;
            } else if (window.judgeme.showReviewForm) {
              window.judgeme.showReviewForm(productId);
              formOpened = true;
            } else if (window.judgeme.openWriteReview) {
              window.judgeme.openWriteReview(productId);
              formOpened = true;
            }
          }
        }
        
        // Method 3: Dispatch custom event that Judge.me might listen to
        if (!formOpened) {
          const productId = newButton.getAttribute('data-product-id');
          const customEvent = new CustomEvent('judgeme:write-review', {
            detail: { productId: productId }
          });
          document.dispatchEvent(customEvent);
        }
        
        return formOpened;
      };
      
      // Try immediately
      let opened = tryOpenReviewForm();
      
      // If not opened, wait for Judge.me to load and try again
      if (!opened) {
        const checkInterval = setInterval(() => {
          opened = tryOpenReviewForm();
          if (opened) {
            clearInterval(checkInterval);
          }
        }, 200);
        
        // Timeout after 3 seconds
        setTimeout(() => {
          clearInterval(checkInterval);
          if (!opened) {
            // Last resort: scroll to review section
            const reviewSection = document.getElementById('product-reviews-section');
            if (reviewSection) {
              reviewSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        }, 3000);
      }
    });

    // Close modal handlers
    if (closeButton) {
      closeButton.addEventListener('click', function() {
        if (messageModal) {
          messageModal.style.display = 'none';
        }
      });
    }

    // Close modal when clicking outside
    if (messageModal) {
      messageModal.addEventListener('click', function(e) {
        if (e.target === messageModal) {
          messageModal.style.display = 'none';
        }
      });
    }

    // Close modal on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && messageModal && messageModal.style.display === 'flex') {
        messageModal.style.display = 'none';
      }
    });
  }

})();

